"use client";

import { useClientTranslations } from "@/hooks/useClientTranslations";
export default function NotFound() {
  const t = useClientTranslations("errors");
  return <div className="flex h-screen items-center justify-center" data-sentry-component="NotFound" data-sentry-source-file="not-found.tsx">
            <div className="text-center">
                <h1 className="text-4xl font-bold">{t("notFound.code")}</h1>
                <p className="text-muted-foreground">{t("notFound.message")}</p>
            </div>
        </div>;
}